import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { colors } from '../../../../utils/colors';

export const ProgressBreakpoint = () => {
	return (
		<>
			<Flex
				justifyContent="flex-start"
				alignItems="center"
				w="100%"
				position="absolute"
			>
				<Flex
					alignItems="center"
					justifyContent="center"
					marginLeft="10%"
					position="relative"
				>
					<Box
						w="4px"
						h="24px"
						bgColor="white"
						position="absolute"
						zIndex="9999"
					/>
					<Box
						position="absolute"
						borderRadius="50%"
						h="12px"
						w="12px"
						bgColor="#1D1D1D"
						zIndex="999999"
					/>
					<Box
						position="absolute"
						borderRadius="50%"
						h="6px"
						w="6px"
						bgColor={colors.primary}
						zIndex="999999"
					/>
				</Flex>
				<Flex
					alignItems="center"
					justifyContent="center"
					marginLeft="25%"
					position="relative"
				>
					<Box
						w="4px"
						h="24px"
						bgColor="white"
						position="absolute"
						zIndex="999"
					/>
					<Box
						position="absolute"
						borderRadius="50%"
						h="12px"
						w="12px"
						bgColor="#1D1D1D"
						zIndex="999999"
					/>
					<Box
						position="absolute"
						borderRadius="50%"
						h="6px"
						w="6px"
						bgColor={colors.primary}
						zIndex="999999"
					/>
				</Flex>
				<Flex
					alignItems="center"
					justifyContent="center"
					marginLeft="35%"
					position="relative"
				>
					<Box
						w="4px"
						h="24px"
						bgColor="white"
						position="absolute"
						zIndex="999"
					/>
					<Box
						position="absolute"
						borderRadius="50%"
						h="12px"
						w="12px"
						bgColor="#1D1D1D"
						zIndex="999999"
					/>
					<Box
						position="absolute"
						borderRadius="50%"
						h="6px"
						w="6px"
						bgColor={colors.primary}
						zIndex="999999"
					/>
				</Flex>
			</Flex>
		</>
	);
};
